export const CUSTOMER_DISPLAY_MEDIA_TYPES = [
  { value: 'IMAGE', label: 'CUSTOMER_DISPLAY_SETTINGS.LIST.IMAGE' },
  { value: 'VIDEO', label: 'CUSTOMER_DISPLAY_SETTINGS.LIST.VIDEO' },
]

export const CUSTOMER_DISPLAY_PAGE_SIZE_OPTIONS = [10, 20, 30, 50]

export const CUSTOMER_DISPLAY_ROUTES = {
  CREATE: '/settings/customer-display/information',
  EDIT: id => `/settings/customer-display/information/${id}`,
}
